<template>
  <div style="width: 100vw;height: auto;background-color: #f4f7f9;position: relative;overflow-x: hidden;overflow-y: auto" class="whole-page">
    <!-- 页面头部 -->
    <div class="header">
      <div class="header-icon" ></div>
      <div class="header-title">教师端虚拟实验模考系统</div>
      <div class="header-pic"
           @click="clickZone">
        <div class="user-card"
             ref="user-card-list"
             v-if="showCard">
          <div class="user-card-pic"></div>
          
            <div style="position:absolute;z-index:999">
              <div class="user-msg">
                <span style="margin-bottom: 0.2vw;display: inline-block">{{username=='250'?'249':username}}</span><br>
                <span>{{'ID：'+(account.length>7?account.slice(0,7)+'...':account)}}</span>
              </div>
            </div>
          
          <div class="user-btn-list">
            <div class="user-card-btn"
                 @click="changeRight('toHome')">
              <img class="user-btn-pic"
                   src="http://data.xiyilab.com/web/main/static/home/p__基本资料大icon-拷贝.png">
              <div class="user-btn-text">个人中心</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- / 页面头部 -->
    <!--  -->

    <div class="teacher-body">

      <div class="teacher-body-left">
        <div class="switch-classroom">
          <div class="icon-classroom"></div>
          <div style="line-height: 40px;height: 40px;white-space: nowrap;width: 3vw;font-size: 0.7vw">班级：</div>
          <el-select placeholder="请选择班级"
                     style="margin-top: auto;width: 8vw;margin-right: 0.5vw"
                     v-model="classroom"
                     @change="changeClassroom">
            <el-option v-for="item in classroomList"
                       :value="JSON.stringify(item)"
                       :label="item.name"
                       :key="item.id">
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="router-btn-group">
          <div class="router-btn"
               v-for="item in routerList"
               @mouseenter="item.active=true"
               @mouseleave="item.active=item.active&&page===item.name"
               @click="switchPage(item.name)">
            <img :src="'http://data.xiyilab.com/web/main/static'+(item.active?item.icon+'_L.png':(item.icon+'_N.png'))"
                 class="router-btn-icon">
            <div class="router-btn-text"
                 :style="{color:item.active?'#5eb2f7':'black'}">{{item.name}}</div>
            <div class="router-btn-right-line"
                 :style="{visibility:item.active?'inherit':'hidden'}"></div>
          </div>
        </div>
      </div>
      <!-- 创建任务页面 -->
      <div class="teacher-body-right" v-if="page==='推荐实验'" style="height: 85vh">

        <div class="select-app-card">
          <div class="task-name-input" ><span> 推荐名称：</span>
            <el-input placeholder="请输入推荐名称"
                      v-model="formData.taskName"></el-input>
          </div>

          <div class="task-date-picker"><span> 有效时间：</span>
            <el-date-picker v-model="formData.time"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            :picker-options="pickerOptions"
                            start-placeholder="开始日期"
                            :clearable="false"
                            end-placeholder="结束日期">
            </el-date-picker>
          </div>

          <div class="subject-select-btn-group" ><span>科目选择：</span>
            <el-checkbox :indeterminate="isIndeterminate"
                         v-model="checkAll"
                         @change="handleCheckAllChange"
                         style="margin-right: 1vw">全选</el-checkbox>
            <el-checkbox-group v-model="checkedCities"
                               @change="handleCheckedCitiesChange">
              <el-checkbox v-for="subject in subjects"
                           :label="subject"
                           :key="subject">{{subject}}</el-checkbox>
            </el-checkbox-group>

          </div>

          <div style="width: 100%;height: 1px ;background-color: silver;margin:1vw auto"></div>
        </div>

        <div class="app-body" style="overflow: auto">
          <div class="app-card"
               v-for="(item,index) in appList"
               v-if="item.show"
               @click="selectApp(item,index)">
            <el-checkbox class="app-checkbox"
                         @change="selectApp(item,index)"
                         v-model="checkClickList[index]"
                         :class="{'on-checkbox':checkClickList[index],'no-on-checkbox':!checkClickList[index]}"></el-checkbox>
            <div class="app-icon" :class="{'phy-back':item.subject==='物理','chem-back':item.subject==='化学','bio-back':item.subject==='生物'}" style="position: relative;overflow: hidden">
              <div class="skin" v-if="isSeller&&!whiteList.find(i=>i==item.name)">
                <div class="skin-cir">
                  <div class="skin-lock"></div>
                  <div class="skin-title"></div>
                </div>

              </div>
              <img :src="item['platforms'][0]['preview_img_uri']"
                   width="120"
                   height="120">
            </div>
            <div class="app-title">{{item.name.length>15?item.name.slice(0,15)+'...':item.name}}</div>
          </div>
        </div>

        <div @click="checkOption"
             style="margin: auto auto 1vw; width: 5rem;height: 2rem;text-align: center;background-color: #5eb2f7;line-height: 2rem;color: white;cursor: pointer;border-radius: 4px">发&nbsp;&nbsp;布</div>

        <el-dialog :visible="dialogVisible"
                   width="35%"
                   top="15vw"
                   :show-close="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false">
          <span slot="title"
                style=" display: flex;flex-wrap: nowrap;">
            <span class="title-icon"></span>
            <span style="margin-left: 1vw">教师推荐</span>
          </span>
          <div class="dialog-body">
            <div class="dialog-line">
              <div class="dialog-icon icon1"></div>
              <div class="dialog-line-text">{{classroom?JSON.parse(classroom).name:''}}</div>
            </div>
            <div class="dialog-line">
              <div class="dialog-icon icon2"></div>
              <div class="dialog-line-text">{{formData.taskName}}</div>
              <div class="finish-status"
                   style="background-color: gray"></div>
              <div class="finish-status-text">未发布</div>
            </div>
            <div class="dialog-line">
              <div class="dialog-icon icon3"></div>
              <div class="dialog-line-text">{{formData.time[0]}}&nbsp;&nbsp;至&nbsp;&nbsp;{{formData.time[1]}}</div>
            </div>
            <div class="dialog-task-app">
              <div class="title-group">
                <div
                  v-for="(item,index) in formData.appList"
                  :key="index"
                  class="task-app-title"
                  :style="{backgroundColor:item.show?'#5eb2f7':'transparent',color:item.show?'white':''}"
                  @click="formData.appList[index].show=!formData.appList[index].show">
                  {{item.name}}</div>
              </div>
              <div class="delete-btn"
                   @click="deleteApp"><i class="el-icon-delete"></i></div>
            </div>

          </div>
          <div class="dialog-foot">
            <div style="background-color: #5eb2f7;color: white;width: 5rem;height: 2rem;line-height: 2rem;border-radius: 4px;cursor: pointer;margin: 0.5rem"
                 @click="handleCanelTask">取消发布</div>
            <div style="background-color: #5eb2f7;color: white;width: 5rem;height: 2rem;line-height: 2rem;border-radius: 4px;cursor: pointer;margin: 0.5rem"
                 @click="handInTask">确定发布</div>
          </div>
        </el-dialog>

      </div>
      <!-- / 创建任务页面 -->

      <!-- 成绩管理页面 -->
      <div class="teacher-body-right" v-if="page==='成绩管理'" style="justify-content: flex-start">
        <div class="mark-manager-header">
          <div class="left-blue-blank"></div>
          <div class="manager-header-router">
            <div class="header-router-btn">
              <span @click="managePage='table'"
                    :style="{color:managePage==='table'?'black':'#a0a0a0'}">成绩管理</span>
            </div>
            <div class="header-router-btn"
                 v-if="managePage==='info'||managePage==='echart'||managePage==='excel'">
              ><span @click="managePage='info'"
                     :style="{color:managePage==='info'?'black':'#a0a0a0'}">推荐详情</span>
            </div>
            <div class="header-router-btn"
                 v-if="managePage==='echart'||managePage==='excel'">
              ><span @click="echartsInit"
                     :style="{color:managePage==='echart'?'black':'#a0a0a0'}">{{selectAppInTask.name}}</span>
            </div>
            <div class="header-router-btn"
                 v-if="managePage==='excel'"
                 style="color: black">
              >查看详情
            </div>
          </div>
        </div>

        <div class="mark-manager-body" v-if="taskList.length>0">
          <div v-if="managePage==='table'" class="task-info-body">

            <!-- 成绩管理头部 -->
            <div class="search-action">
              <div v-if="searchInput.length>0"
                   class="search-result">搜索到“{{taskList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase())).length}}"个结果
              </div>
              <div style="line-height: 40px;margin-right: 1vw;color: #cad1d7;cursor: pointer"
                   @click="deleteTask('')">批量删除</div>
              <el-input v-model="searchInput"
                        placeholder="请输入推荐名"
                        style="width: 10vw;margin: auto 0 auto;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);min-width: 200px"
                        suffix-icon="el-icon-search">
              </el-input>
            </div>
            <!-- / 成绩管理头部 -->

            <keep-alive>
              <!-- 成绩管理表格 -->
              <el-table v-if="taskList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase())).length>0"
                        :cell-style="{height:'4.5vh',padding:'0px'}"
                        :header-cell-style="{background:'rgb(229,229,229)',color:'rgb(144, 147, 153)',fontWeight:'600',height:'6vh',padding:'0px'}"
                        ref="multipleTable"
                        :data="taskList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase()))"
                        tooltip-effect="dark"
                        border
                        fit
                        style="height: 70vh;"
                        class="task-table"
                        highlight-current-row
                        @select-all="handleSelectionChange"
                        @select="handleSelectionChange">
                <!-- 表格单选框 -->
                <el-table-column type="selection" width="40" >
                </el-table-column>

                <el-table-column type="index" label="序号"
                                 width="70"
                                 align="center">
                  <!-- <template slot-scope="scope">
                    {{scope.$index+1}}
                  </template> -->
                </el-table-column>
                <el-table-column prop="name" label="实验名称"
                                 align="center">
                </el-table-column>
                <el-table-column prop="classroom" label="班级"
                                 align="center">
                </el-table-column>
                <el-table-column prop="startTime" label="开始时间"
                                 sortable
                                 align="center"></el-table-column>
                <el-table-column prop="endTime" label="截止时间"
                                 sortable
                                 align="center"></el-table-column>
                <el-table-column prop="status" label="状态"
                                 align="center">
                  <template slot-scope="scope">
                    <div class="status-tag"
                         v-if="scope.row.status==='rejected'">
                      <div class="status-reject"></div>未开始
                    </div>
                    <div class="status-tag"
                         v-if="scope.row.status==='pending'">
                      <div class="status-pending"></div>进行中
                    </div>
                    <div class="status-tag"
                         v-if="scope.row.status==='resolved'">
                      <div class="status-resolve"></div>已完成
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作"
                                 width="100"
                                 align="center">
                  <template slot-scope="scope">
                    <!-- 操作的编辑按钮 -->
                    <el-button @click="handleClick(scope.row)"
                               type="text"
                               size="small"
                               class="table-to-info">
                    </el-button>
                    <!-- 操作的删除按钮 -->
                    <el-button type="text"
                               size="small"
                               class="table-delete-btn"
                               @click="deleteTask(scope.row)">
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="search-no-result">
                <div class="search-no-result-img"></div>
              </div>
              <!-- / 成绩管理表格 -->
            </keep-alive>

            <!-- 删除已完成任务弹出层 -->
            <el-dialog :visible="delVisible"
                       width="15%"
                       center
                       top="25vw"
                       :show-close="false"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false">
              <span slot="title"
                    style=" display: flex;flex-wrap: nowrap;">
                <span class="title-icon table-delete-btn"></span>
                <span style="margin-left: 1vw">删除任务</span>
              </span>
              <span style="display: inline-block;width: 100%;text-align: center"> 任务删除不可找回，确认删除推荐？</span>
              <span slot="footer"
                    class="dialog-footer">
                <el-button @click="delVisible=false;$refs.multipleTable.clearSelection()">取消</el-button>
                <el-button type="primary"
                           @click="handleDeleteTask">确定</el-button>
              </span>
            </el-dialog>
            <!-- 删除未完成任务弹层 -->
            <el-dialog :visible="delErrVisible"
                       width="15%"
                       center
                       top="25vw"
                       :show-close="false"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false">
              <span slot="title"
                    style=" display: flex;flex-wrap: nowrap;">
                <span class="title-icon table-delete-btn"></span>
                <span style="margin-left: 1vw">删除推荐</span>
              </span>
              <span style="display: inline-block;width: 100%;text-align: center"> 当前有推荐未完成不可进行删除操作！</span>
              <span slot="footer"
                    class="dialog-footer">
                <el-button type="primary"
                           @click="delErrVisible=false;$refs.multipleTable.clearSelection()">知道了</el-button>
              </span>
            </el-dialog>
          </div>

          <!-- / 成绩管理表格 -->

          <!-- 任务详情页面 -->
          <div v-if="managePage==='info'" style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;min-height: 70vh">
            <div class="task-title">
              <div class="task-name">
                <div class="task-name-icon icon-name"></div>
                <span class="justify">推荐名称</span><span>：{{selectTask.name}}</span>
              </div>
              <div class="task-name">
                <div class="task-name-icon icon-classroom-info"></div>

                <span class="justify">班级</span><span>：{{selectTask.classroom}}</span>

              </div>
              <div class="task-name ">
                <div class="task-name-icon icon-time"></div>
                <span class="justify">有效时间</span><span>：{{selectTask.startTime}}&nbsp;&nbsp;至&nbsp;&nbsp;{{selectTask.endTime}}</span>
              </div>
              <div class="task-name">
                <div class="task-name-icon icon-star"></div>
                <span class="justify">推荐内容</span>：
              </div>
            </div>

            <div class="app-card-group" >
              <div class="app-card"
                   v-for="(item,index) in selectTask.appList"
                   :key="index"
                   @click="getStudentList(item)">
                <div class="app-icon" :class="{'phy-back':item.subject==='物理','chem-back':item.subject==='化学','bio-back':item.subject==='生物'}">
                  <img :src="item['platforms'][0]['preview_img_uri']"
                       width="120"
                       height="120">
                </div>
                <div class="app-title">{{item.name.length>15?item.name.slice(0,15)+'...':item.name}}</div>
              </div>
            </div>
          </div>
          <!-- / 任务详情页面 -->

          <!-- 提交情况 -->
          <div v-if="managePage==='echart'" style=" margin:0;  display: flex;flex-direction: column;justify-content: center;width: 100%">
            <div class="e-chart">
              <div class="chart-left">
                <div class="chart-left-title">提交情况</div>
                <!-- 控制台报错 解决 ===> v-if="!isNaN"   -->
                <el-progress  type="circle" :percentage='studentCount' style="margin-bottom: 1vw;margin-top: 1vw" :format="showText" show-text></el-progress>
                <div class="chart-left-content">
                  <div class="content-round-1"></div>
                  <div >未提交</div>
                  <div class="content-round-2"></div>
                  <div >已提交</div>
                </div>
              </div>
              <div class="chart-right">
                <div id="myChart" style="width: 30vw;height: 100%;margin: auto;"></div>
              </div>
            </div>

            <el-table ref="studentTable"
                      :data="studentExamList"
                      tooltip-effect="dark"
                      border
                      fit
                      highlight-current-row
                      style="width: 100%; margin-top:20px">
              <el-table-column prop="name"
                               label="姓名"
                               align="center"></el-table-column>
              <el-table-column prop="number"
                               label="学号"
                               align="center"></el-table-column>
              <el-table-column :formatter="sumMark"
                               label="成绩"
                               align="center"></el-table-column>
              <el-table-column label="操作"
                               width="200"
                               align="center">
                <template slot-scope="scope" style="display: flex;justify-content: center;align-items: center">
                  <el-button @click="getExcel(scope.row)"
                             type="text"
                             size="small"
                             class="table-to-info"></el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <!-- / 提交情况 -->

          <div v-if="managePage==='excel'"
               style="display: flex;flex-wrap: nowrap;overflow: auto">
            <div class="excel">
              <div style="width:63vw;height: 70vh;display: flex;align-items: center;justify-content: center;margin: 0 auto 0">
                <webgl :options="webglOptions" width="1060px" height="60vh" ></webgl>
              </div>
              <div class="exam-pic">
                <img :src="selectAppInTask['platforms'][0]['app_uri']+'/scoring.png'" width="1100" height="700">
                <div class="markList">
                  <div :style="{top:'0px'}" class="mark-review-btn">
                    <div class="mark-review-mark">得分</div>
                  </div>
                  <div v-for="item in posMarkList" :style="{top:item.position+'px'}" class="mark-review-btn">
                    <div class="mark-review-mark">{{item.mark}}</div>
                    <!--<div class="mark-review-review">-->
                    <!--  <i class="el-icon-video-play"></i>-->
                    <!--</div>-->
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div v-else
             class="no-task-img">
          <div class="search-action"
               style="width: 90%;margin: 1vw auto">
            <div style="line-height: 40px;margin-right: 1vw;color: #cad1d7">批量删除</div>
            <el-input placeholder="请输入推荐名"
                      style="width: 10vw;margin: auto 0 auto;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);min-width: 200px"
                      suffix-icon="el-icon-search"></el-input>
          </div>
          <div class="no-context">当前班级还没有发布的推荐哦！</div>
          <div class="to-create"
               @click="page='推荐实验'">
            去发布&nbsp;<i class="el-icon-right"
                        style="border-radius: 50%;background-color: #5eb2f7;color: white"></i>
          </div>
        </div>

        <div v-show="taskList.length>0" class="mark-manager-footer">
          <div v-show="managePage==='table'">
            <el-pagination
              @current-change="handleCurrentChange($event,'task')"
              hide-on-single-page
              :current-page="taskPage.page"
              :page-size="taskPage.limit"
              layout="prev, pager, next"
              :total="taskPage.total">
            </el-pagination>
          </div>
          <div v-show="managePage==='echart'">
            <el-pagination
              @current-change="handleCurrentChange($event,'student')"
              :current-page="studentPage.page"
              :page-size="studentPage.limit"
              hide-on-single-page
              layout="prev, pager, next"
              :total="studentPage.total">
            </el-pagination>

          </div>
        </div>

      </div>
      <!-- / 成绩管理页面 -->

    </div>

    <!-- 退出登录 -->
    <el-dialog :visible="logout"
               width="30%"
               title="警告">
      <span>确认退出吗？当前未保存的操作将全部失效！！！</span>
      <template slot="footer">
        <el-button @click="logout=false">取消</el-button>
        <el-button @click="logOut">确认</el-button>
      </template>
    </el-dialog>
    <!-- / 退出登录 -->

  </div>
</template>




<script>
import { getAppInfo, getJSON, getOnlineAppList } from '@/api/app'
const whiteList=['探究平面镜成像的特点','粗盐中难溶性杂质的去除','观察人血永久涂片']
const localDate = new Date()
import AppCard from '@/components/AppCard'

import {getToken, removeToken} from '@/utils/auth'
import { getTask, submitTask } from '@/api/task'
import {
  getClassroomList,
  getClassroomStudentList,
  getClassroomTaskStudentList,
  getTeacherClassroomList
} from '@/api/school'
import DevicePixelRatio from "@/plugins/devicePixelRatio";
import $ from 'jquery'
import webgl from "@/components/webgl";
export default {
  name: 'teacherExam_desktop',
  components: {
    AppCard,
    webgl
  },
  mounted () {
    let that=this
    document.onclick = function () {
      that.$nextTick(()=>{
        that.showCard=false
      })
    }
    getTeacherClassroomList(sessionStorage.getItem('uid')).then(res => {
      if (res.status === 'ok') {
        getClassroomList(1, 300).then(resClassList => {
          if (resClassList.status === 'ok') {
            for (let i = 0; i < res.data.length; i++) {
              let data = {
                id: res.data[i].class_id,
                name: resClassList.data.find(item => item.id === res.data[i].class_id)&&resClassList.data.find(item => item.id === res.data[i].class_id).name
              }
              this.classroomList.push(data)
            }
          }
        })
      }
    })
    this.router = JSON.parse(sessionStorage.getItem('router'))
    this.checkClickList = new Array(this.appList.length)
    this.checkHoverList = new Array(this.appList.length)
    getOnlineAppList(1, 300,'&usage=模拟考试').then(res => {
      if (res.status === 'ok') {
        for (let i = 0; i < res.data.length; i++) {
          // console.log(res.data[i])
          res.data[i]['show'] = true
          if (this.appList.findIndex(item => item.id === res.data[i].id) === -1) {
            this.appList.push(res.data[i])
            this.checkClickList.push(false)
          }
        }
      }
    })
    for (let i = 0; i < this.appList.length; i++) {
      this.checkHoverList[i] = false
    }
    this.username = sessionStorage.getItem('uid')
    this.account = sessionStorage.getItem('account')
    this.nowDate = localDate
    let token = sessionStorage.getItem('token')
    this.loginStatus = token ? true : false
    let userdata = {
      email: sessionStorage.getItem('email'),
      phone: sessionStorage.getItem('phone'),
      uid: sessionStorage.getItem('uid'),
      hasPwd: sessionStorage.getItem('hasPwd'),
      user_type: sessionStorage.getItem('user_type'),
      leastDate: sessionStorage.getItem('leastDate'),
      token: sessionStorage.getItem('token')
    }
    if (token) {
      this.$store.dispatch('User/reLogin', userdata)
    }
    for (let i = 0; i < this.routerList.length; i++) {
      if (this.routerList[i].active) {
        this.page = this.routerList[i].name
      }
    }
  },
  data () {
    return {
      isChecked:false,
      timer:null,
      whiteList:whiteList,
      isSeller:false,
      dateTime:'',
      studentCount:0,
      submitText:'',
      webglOptions:{
        app_uri:'https://data.xiyilab.com/apps/webgl/同步实验/人教版/生物/观察动物细胞和植物细胞/Build/观察动物细胞和植物细胞.json',
        subject:'生物',
        platform:'webgl',
        mode:3,
        url:'https://api.xiyilab.com/v1',
        publisher:'人教版',
        grade:'八年级',
        chapter:'第一章',
        app_info_img_url:'https://data.xiyilab.com/',
        app_id:0,
        app_platform_id:'1',
        task_id:'0',
        user_id:''
      },
      account: '',
      username: '',
      showCard: false,
      router: [],
      page: '成绩管理',
      managePage: 'table',
      loginStatus: getToken() ? true : false,
      classroom: '', // 班级
      formData: {
        taskName: '',
        time: '',
        appList: []
      },
      logout: false,
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      openEchart: false,
      dialogVisible: false,
      delVisible: false,
      delErrVisible: false,
      searchInput: '',
      searchResult: 0,
      selectTask: {},
      selectAppInTask: {},
      selectStudent: {
      },
      taskStatus: '未开始',
      nowDate: '',
      excel:{
        title:'123',
        tableList:[1,23,44],
        itemContent:'123',
        sumContent:'123',
        step:[],
        sumMark:'100分'
      },
      checkClickList: undefined,
      checkHoverList: undefined,
      //////////多选框////////////
      checkAll: true,
      checkedCities: ['物理', '化学', '生物'],
      subjects: ['物理', '化学', '生物'],
      isIndeterminate: true,
      //////////////////////////////
      delList: [],
      studentExamList: [],
      markList: [],
      taskList: [],  // 成绩管理表格的数据
      taskPage: {
        total: 0,
        page: 1,
        limit: 13
      },
      taskname: '',
      classroomList: [],
      routerList: [
        { icon: '/exam/icon_创建任务', name: '推荐实验', path: '/tasks', active: true },
        { icon: '/exam/icon_成绩管理', name: '成绩管理', path: '/manager', active: false }
      ],
      appList: [],
      posMarkList:[],
      reslutMark: [], // 改动过
      studentPage: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  watch: {
    classroom:function () {
      this.taskPage.page=1
      this.taskPage.total=0
      let classroom
      try {
        classroom = JSON.parse(this.classroom)
      }
      catch {
        classroom = {
          id: 0,
          name: '未选择'
        }
      }
      getTask(classroom.id, this.taskPage.page, this.taskPage.limit).then(res => {
        if (res.status === 'ok') {
          this.taskPage.page = res.page.current_page
          this.taskPage.total = res.page.total
          this.taskList = []
          let date=new Date()
          for (let i = 0; i < res.data.length; i++) {
            let end=new Date(res.data[i]['end_at'])
            let start=new Date(res.data[i]['start_at'])
            // res.data[i].status === 0 ? 'rejected' : res.data[i].status === 1 ? 'pending' : 'resolved'
            let data = {
              id: res.data[i].id,
              name: res.data[i].name,
              classroom: classroom.name,
              startTime: res.data[i]['start_at'],
              endTime: res.data[i]['end_at'],
              status: date<start?'rejected':date>end?'resolved':'pending',
              count: '无法获取',
              creator_id: res.data[i]['creator_id'],
              appList: res.data[i].apps
            }

            this.taskList.push(data)
          }

        }
      })
    },
    formData:function () {
      // if(!this.formData.time){
      //   this.formData.time=[]
      // }
    },
    page: function () {
      if (this.page === '成绩管理') {
        let classroom
        try {
          classroom = JSON.parse(this.classroom)
        }
        catch {
          classroom = {
            id: 0,
            name: '未选择'
          }
        }
        getTask(classroom.id, this.taskPage.page, this.taskPage.limit).then(res => {
          if (res.status === 'ok') {
            this.taskPage.page = res.page.current_page
            this.taskPage.total = res.page.total
            this.taskList = []
            let date=new Date()
            for (let i = 0; i < res.data.length; i++) {
              let end=new Date(res.data[i]['end_at'])
              let start=new Date(res.data[i]['start_at'])
              // res.data[i].status === 0 ? 'rejected' : res.data[i].status === 1 ? 'pending' : 'resolved'
              let data = {
                id: res.data[i].id,
                name: res.data[i].name,
                classroom: classroom.name,
                startTime: res.data[i]['start_at'],
                endTime: res.data[i]['end_at'],
                status: date<start?'rejected':date>end?'resolved':'pending',
                count: '无法获取',
                creator_id: res.data[i]['creator_id'],
                appList: res.data[i].apps
              }

              this.taskList.push(data)
            }

          }
        })
      }
    },
    managePage:function (){
      if(this.managePage==='echart'){

      }
    }
  },
  methods: {
    clickZone(e){
      e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
      this.showCard=!this.showCard
    },
    changeStatus(row,column){

    },
    showText(){
      return this.submitText

    },
    sumMark(row,column,cellValue,index){
      console.log(row)
      let mark=row['scores']
      let sum=0
      for(let i=0;i<mark.length/2;i++){
        sum+=parseInt(mark[i])
      }
      return sum
    },
    inAppDiv (index) {
      this.checkHoverList[index] = true
    },
    outAppDiv (index) {
      this.checkHoverList[index] = false
    },
    handleCheckAllChange (val) {
      this.checkedCities = val ? ['物理', '化学', '生物'] : [];
      this.isIndeterminate = false;
      for (let i = 0; i < this.appList.length; i++) {
        this.appList[i].show = val
      }
    },
    handleCheckedCitiesChange (value) {
      let that = this
      for (let i = 0; i < that.appList.length; i++) {
        that.appList[i].show = false
        if (value.find(item => item === that.appList[i].subject)) {
          that.appList[i].show = true
        }
        console.log(this.appList)
      }
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.subjects.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.subjects.length;
    },
    selectApp (item, index) {
      //console.log('触发前',this.checkClickList)
      if(this.isSeller){
        if(!whiteList.find(i=>item.name==i)){
          console.log(123)
          this.$message.error('当前账号无法选择')
        }
        else{
          this.checkClickList[index] = !this.checkClickList[index]
          if (this.checkClickList[index] === true) {
            let app = Object.assign({}, item)
            app.show = false
            this.formData.appList.push(app)
            this.formData.appList=this.unique(this.formData.appList)
          }
          else{
            let i=this.formData.appList.findIndex(e=>e.id===item.id)
            console.log(i,this.formData.appList.length)
            this.formData.appList.splice(i,1)
          }
          //console.log('触发后',this.checkClickList)
        }
      }
      else{
        this.checkClickList[index] = !this.checkClickList[index]
        if (this.checkClickList[index] === true) {
          let app = Object.assign({}, item)
          app.show = false
          this.formData.appList.push(app)
          this.formData.appList=this.unique(this.formData.appList)
        }
        else{
          let i=this.formData.appList.findIndex(e=>e.id===item.id)
          console.log(i,this.formData.appList.length)
          this.formData.appList.splice(i,1)
        }
        //console.log('触发后',this.checkClickList)
      }

    },
    handleCanelTask(){
      console.log(this.formData.appList,this.checkClickList)
      // for(let i=0;i<this.checkClickList;i++){
      //
      //   this.checkClickList[i]=false
      //
      // }
      // let that=this;
      // this.$nextTick(()=>{
      //   for(let i=0;i<this.appList;i++){
      //     that.appList[i].show=false
      //     console.log(that.appList)
      //   }
      // })
      // console.log(that.appList)
      this.dialogVisible=false
    },
    unique(songs){
      let result = {};
      let finalResult=[];
      for(let i=0;i<songs.length;i++){
        result[songs[i].id]=songs[i];
        //因为songs[i].name不能重复,达到去重效果,且这里必须知晓"name"或是其他键名
      }
      //console.log(result);{"羽根":{name:"羽根",artist:"air"},"晴天":{name:"晴天",artist:"周杰伦"}}
      //现在result内部都是不重复的对象了，只需要将其键值取出来转为数组即可
      for(let item in result){
        finalResult.push(result[item]);
      }
      //console.log(finalResult);[{name:"羽根",artist:"air"},{name:"晴天",artist:"周杰伦"}]
      return finalResult;
    },
    checkOption () {
      // this.formData.appList = this.formData.appList.filter(function (item, index, self) {
      //   return self.findIndex(el => el['name'] == item['name']) === index
      // })
      for(let i=0;i<this.checkClickList.length;i++){
        if(this.checkClickList[i]&&this.formData.appList.findIndex(item=>item.id==this.appList[i].id)==-1){
          let app = Object.assign({}, this.appList[i])
          app.show = false
          this.formData.appList.push(app)
        }
      }
      if (this.formData.taskName && this.formData.time && this.formData.appList.length > 0 && this.classroom ) {
        this.dialogVisible = true
      }
      else {
        this.$message.error('请检查班级、推荐名称、有效时间或推荐实验列表')
      }
      console.log(this.formData)
    },
    deleteTask (row) { // 删除操作
      this.$message.error('暂时不能执行删除操作')
      console.log(row,'row')
      console.log(this.delList,'123')
      // if (row && row.status !== 'resolved') {
      //   console.log(234 + 'err')
      //   this.delErrVisible = true
      // }
      // else if (row) {
      //   console.log(234)
      //   this.delList = []
      //   this.delList.push(row)
      //   this.delVisible = true
      // }
      // else {
      //   console.log(123)

      //   console.log(this.delList)
      //   let flag = 0
      //   for (let i = 0; i < this.delList.length; i++) {
      //     if (this.delList[i].status !== 'resolved') {
      //       flag = 1
      //       break
      //     }
      //   }
      //   if (flag === 0) {
      //     this.delVisible = true

      //     console.log(this.delList)
      //   }
      //   else {
      //     console.log(123 + 'err')
      //     this.delErrVisible = true
      //   }
      // }
    },
    btnAll(){ // 全选按钮
      this.isChecked = true
      if(this.isChecked){
        alert('选中啦')

      }


    },
    getStudentList (item) {
      this.selectAppInTask = item;
      getClassroomTaskStudentList(this.studentPage.page, 1000, this.selectTask.id).then(res => {
        if (res.status === 'ok') {
          // 改动过start
          this.reslutMark =res.data
          // 改动过end

          this.markList=[]
          this.studentExamList=[]
          // {name:'wkq',student_id:'123',time:'123',submitTime:'4312',totalMark:'123',mark:[],appName:''}

          //
          // let sum=0
          // this.markList.push(mark)
          // for(let i=0;i<mark.length/2;i++){
          //   sum+=(parseInt(mark[i]))  res.data里面的每一项，里面的每一个scores，里面的每一项
          // }
          for (let i = 0; i < res.data.length; i++) {
            let studentData={
              name:'',
              number:'',
              scores:'',
              user_id:''
            }
            for(let j=0;j<res.data[i]['scores'].length;j++){

              if(res.data[i]['scores'][j].app_platform_id===item['platforms'][0].id){
                let mark = res.data[i]['scores'][j]['score'].split(",")
                studentData.name=res.data[i].name
                studentData.user_id=res.data[i].user_id
                studentData.number=res.data[i].number
                studentData.scores=mark
                this.studentExamList.push(studentData)
                this.markList.push(mark)
              }
            }
          }
          this.studentPage.page = res.page.current_page
          this.studentPage.total=res.page.total
          getClassroomStudentList(1,100,JSON.parse(this.classroom).id).then(res2=>{
            this.submitText=this.markList.length+'/'+res2.page.total
            if( this.markList.length === 0){
              this.studentCount=0
            } else {
              this.studentCount=Math.floor(this.markList.length/res2.page.total*100)
            }
            this.studentPage.total = this.markList.length
            this.echartsInit(res2.page.total)
          })

        }
      })
    },
    echartsInit () {
      let echartMark=[]
      this.managePage='echart'
      console.log(this.selectAppInTask,this.studentExamList)
      getClassroomTaskStudentList(this.studentPage.page, this.studentPage.total, this.selectTask.id).then(res => {
        if (res.status === 'ok') {
          for (let i = 0; i < res.data.length; i++) {
            let studentData={
              name:'',
              number:'',
              scores:'',
              user_id:''
            }
            if(this.selectAppInTask['platforms'][0].id){
              // 改动过start
              this.reslutMark.forEach(ele => {
                ele.scores.forEach(item => {
                  if(item.app_platform_id === this.selectAppInTask['platforms'][0].id){
                    let mark = item.score.split(",")
                    studentData.name=res.data[i].name
                    studentData.user_id=res.data[i].user_id
                    studentData.number=res.data[i].number
                    studentData.scores=mark
                    echartMark.push(mark)
                  }
                })
              });
              // 改动过end

            }
          }

          let len = echartMark[0].length/2
          //len=JSON.parse(res.data)['stepContent'].split('|').length-2
          let xData = new Array(parseInt(len))

          for (let j = 0; j < xData.length; j++) {
            let data = 0;
            for (let i = 0; i < echartMark.length; i++) {
              if (echartMark[i][j + xData.length] == "True") {
                data++
              }
            }
            xData[j] = parseInt(data/echartMark.length*100)
          }
          let label = new Array(xData.length)
          for (let i = 0; i < label.length; i++) {
            label[i] = '步骤' + (i+1)
          }

          this.$nextTick(() => {
            let myChart = this.$echarts.init(document.getElementById('myChart'))
            // 开始渲染
            myChart.setOption({
              title: { text: '成绩统计' },
              tooltip: {},
              xAxis: {
                data: label,
                z:10
              },
              yAxis: {
                type: 'value',
                min: 0,
                axisLabel: {
                  show: true,
                  interval: 'auto',
                  formatter: '{value} %'
                },
                max: 100,
              },
              series: [{
                name: '合格率',
                type: 'bar',
                data: xData,
              }]
            })
          })


        }
      })



    },
    toReplay(item){
      console.log(item,'item')
      console.log(this.selectAppInTask)
      let routeUrl=this.$router.resolve({
        path: '/webGL',
        query: {
          platform: 'webgl',
          mode: 3,
          user_id:item.user_id,
          name:this.selectAppInTask.name,
          app_uri:this.selectAppInTask.platforms[0].app_uri,
          subject: this.selectAppInTask.subject,
          publisher: this.selectAppInTask.publisher,
          grade: this.selectAppInTask.grade,
          chapter: this.selectAppInTask.chapter,
          task_id: this.selectTask.id,
          app_id: this.selectAppInTask['platforms'][0].app_id,
          app_platform_id: this.selectAppInTask['platforms'][0].id
        }
      })
      window.open(routeUrl .href, '_blank');
    },
    getExcel(row){

      this.managePage='excel';
      console.log(row)
      this.selectStudent=row;
      getJSON(this.selectAppInTask['platforms'][0].id).then(res=>{
        if(res.status==='ok'){
          this.posMarkList=[]
          console.log(this.markList,JSON.parse(res.data))
          let position=JSON.parse(res.data).position
          let list=row['scores']
          let len=list.length/2
          let sum=parseInt(0)
          for(let i=0;i<list.length/2;i++){
            let data={
              mark:'',
              isTure:'',
              position:''
            }

            data.mark=parseInt(list[i])
            sum=sum+data.mark
            console.log(sum)
            console.log(len+i)
            data.isTure=list[parseInt(len+i)]
            data.position=position[i]
            this.posMarkList.push(data)
          }
          let data={
            mark:sum,
            isTure:false,
            position:JSON.parse(res.data).position[JSON.parse(res.data).position.length-1]
          }
          this.posMarkList.push(data)
          console.log(this.posMarkList,'post')

        }
      })
      // webglOptions:{
      //   app_uri:'https://data.xiyilab.com/apps/webgl/同步实验/人教版/生物/观察动物细胞和植物细胞/Build/观察动物细胞和植物细胞.json',
      //     subject:'生物',
      //     platform:'webgl',
      //     mode:3,
      //     url:'https://api.xiyilab.com/v1',
      //     publisher:'人教版',
      //     grade:'八年级',
      //     chapter:'第一章',
      //     app_info_img_url:'https://data.xiyilab.com/',
      //     app_id:0,
      //     app_platform_id:'1'
      // },
      this.webglOptions.app_uri='https://api.xiyilab.com/v1/unity/webgl-loader-config?app_id='+this.selectAppInTask.id+'?memory='+268435456
      this.webglOptions.app_id=this.selectAppInTask.id
      this.webglOptions.subject=this.selectAppInTask.subject
      this.webglOptions.publisher=this.selectAppInTask.publisher
      this.webglOptions.grade=this.selectAppInTask.grade
      this.webglOptions.chapter=this.selectAppInTask.chapter
      this.webglOptions.app_platform_id=this.selectAppInTask['platforms'][0].id
      this.webglOptions.task_id=this.selectTask.id
      this.webglOptions.user_id=this.selectStudent.user_id
    },

    deleteApp () {
      let delList = []
      for (let i = 0; i < this.formData.appList.length; i++) {
        if (this.formData.appList[i].show) {
          delList.push(i)
        }
      }
      if (this.formData.appList.length - delList.length < 1) {
        this.$message.error('最少需要选择一个实验')
      }
      else {
        for (let i = 0; i < delList.length; i++) {
          this.formData.appList.splice(delList[i] - i, 1)
        }
      }
    },
    // handleSizeChange(size,target){
    //   if(target==='task'){
    //     getTask(JSON.parse(this.classroom).id,this.taskPage.page,size).then(res=>{
    //       if(res.status==='ok'){
    //         this.taskPage.page=res.page.page
    //         this.taskPage.total=res.page.total
    //         this.taskList=[]
    //         for(let i=0;i<res.data.length;i++){
    //           let data={
    //             id:res.data[i].id,
    //             name:res.data[i].name,
    //             classroom:classroom.name,
    //             startTime:res.data[i]['start_at'],
    //             endTime:res.data[i]['end_at'],
    //             status:res.data[i].status===0?'rejected':res.data[i].status===1?'pending':'resolved',
    //             count:'无法获取',
    //             creator_id:res.data[i]['creator_id'],
    //             appList:res.data[i].apps
    //           }
    //
    //           this.taskList.push(data)
    //         }
    //
    //       }
    //     })
    //   }
    //   else{
    //     getClassroomTaskStudentList(this.studentPage.page,size,this.selectTask.id).then(res=>{
    //       console.log(res)
    //       if(res.status==='ok'){
    //         // {name:'wkq',student_id:'123',time:'123',submitTime:'4312',totalMark:'123',mark:[],appName:''}
    //         this.studentExamList=res.data
    //         this.studentPage.page=res.page.page
    //         this.studentPage.total=res.page.total
    //       }
    //     })
    //   }
    // },
    handleCurrentChange (page, target) {
      let that = this
      if (target === 'task') {
        getTask(JSON.parse(this.classroom).id, page, this.taskPage.limit).then(res => {
          if (res.status === 'ok') {
            this.taskPage.page = res.page.current_page
            this.taskPage.total = res.page.total
            this.taskList = []
            let date=new Date()
            for (let i = 0; i < res.data.length; i++) {
              let end=new Date(res.data[i]['end_at'])
              let start=new Date(res.data[i]['start_at'])
              // res.data[i].status === 0 ? 'rejected' : res.data[i].status === 1 ? 'pending' : 'resolved'
              let data = {
                id: res.data[i].id,
                name: res.data[i].name,
                classroom: JSON.parse(this.classroom).name,
                startTime: res.data[i]['start_at'],
                endTime: res.data[i]['end_at'],
                status: date<start?'rejected':date>end?'resolved':'pending',
                count: '无法获取',
                creator_id: res.data[i]['creator_id'],
                appList: res.data[i].apps
              }

              this.taskList.push(data)
            }

          }
        })
      }
      else {
        getClassroomTaskStudentList(page, this.studentPage.limit, this.selectTask.id).then(res => {
          console.log(res)
          if (res.status === 'ok') {
            this.studentExamList=[]
            // {name:'wkq',student_id:'123',time:'123',submitTime:'4312',totalMark:'123',mark:[],appName:''}
            for (let i = 0; i < res.data.length; i++) {
              let studentData={
                name:'',
                number:'',
                scores:'',
                user_id:''
              }
              for(let j=0;j<res.data[i]['scores'].length;j++){
                if(res.data[i]['scores'][j].app_platform_id===this.selectAppInTask['platforms'][0].id){
                  let mark = res.data[i]['scores'][j]['score'].split(",")
                  studentData.name=res.data[i].name
                  studentData.user_id=res.data[i].user_id
                  studentData.number=res.data[i].number
                  studentData.scores=mark
                  this.studentExamList.push(studentData)
                  this.markList.push(mark)
                }
              }
            }
            this.studentPage.page = res.page.current_page
            this.studentPage.total = res.page.total
          }
        })
      }
    },
    handInTask () {
      console.log(this.formData)
      let app_id = []
      for (let i = 0; i < this.formData.appList.length; i++) {
        app_id.push(this.formData.appList[i].id)
      }
      let data = {
        class_id: JSON.parse(this.classroom).id,
        name: this.formData.taskName,
        start_at: this.formData.time[0],
        end_at: this.formData.time[1],
        apps: app_id
      }
      submitTask(data).then(res => {
        if (res.status === 'ok') {
          this.$message.success('成功')
          this.dialogVisible = false
        }
        else {
          this.$message.error('失败')
          this.dialogVisible = false
        }
      }).catch(e => {
        this.$message.error(e)
        this.dialogVisible = false
      })
    },
    handleSelectionChange (rowlist) {
      this.delList = rowlist
      console.log(this.delList)
    },
    handleClick (scope) {
      console.log(scope)
      this.managePage = 'info'
      this.selectTask = scope
      // console.log(this.selectTask.appList[0]['platforms'][0]['preview_img_uri'])
    },
    logOut () {
      this.$store.dispatch('User/logout')
      this.logout = false
      sessionStorage.clear()
      window.close()
      // setTimeout(() => {
      //
      //   if (this.$route.path !== '/') {
      //     this.$router.push('/')
      //   }
      //   else {
      //     this.$router.go(0);
      //   }
      // }, 500)
    },
    changeClassroom (select) { // 班级发生变化的时候触发
      if(this.page === '成绩管理' && this.classroom === select){
        // alert('根据当前班级渲染成绩管理表格')
        this.managePage='table'
      }
    },
    switchPage (name) { // 触发任务发布和成绩管理页面显示与否
      let that = this
      if (this.classroom) {
        that.$nextTick(() => {
          for (let i = 0; i < that.routerList.length; i++) {
            that.routerList[i].active = false
          }
          that.routerList.find(item => item.name === name).active = true
          that.page = name
        })

      }
      else {
        this.$message.error('请先选择班级')
      }
    },
    handleDeleteTask () {
      this.delVisible = false
      console.log(this.delList.length)
      for (let i = 0; i < this.delList.length; i++) {
        let index = this.taskList.findIndex(item => item === this.delList[i])
        console.log(index)
        if (index !== -1) {
          this.taskList.splice(index, 1)
        }

      }
      console.log(this.taskList)
      this.$refs.multipleTable.clearSelection();
    },
    changeRight (title) {
      if(title==='toHome'){
        this.$router.push('/home_desktop')
      }
    },
    resizeCanvas(e){
      let that=this
      let now=new Date()
      if(now-that.timer>500){
        setTimeout(()=>{
          $("#canvas").attr("width", 1100);
          $("#canvas").attr("height", 700);
          let canvas = document.getElementById('canvas');
          let context = canvas.getContext('2d');
          let image = new Image();
          image.src = '/陕西实验操作评分细则(1)/化/1.粗盐中难溶性杂质的去除.png';
          image.onload = function () {
            // 加载图片后，边截取图片且缩放展示在画布左上角
            context.drawImage(image,0,0,1100,700);
            context.fillText('123',1100-100,150)
          }
          that.timer=now
        },500)
      }



    }
  },
  created() {
      //new DevicePixelRatio().init();
      window.addEventListener('resize',this.resizeCanvas)
      if(sessionStorage.getItem('isSeller')){
        if(sessionStorage.getItem('isSeller')=='true'){
          this.isSeller=true
        }
        else {
          this.isSeller=false
        }
      }
  }

}
</script>





<style scoped>
.task-table /deep/ .cell{
  white-space: nowrap;

}
.skin{
  border-radius: 10px   10px 0 0;
  position: absolute;
  width: 100%;
  height: 22vh;
  background-color: rgba(0,0,0,.25);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.skin-cir{
  position: relative;

  background-image: url("http://data.xiyilab.com/web/main/static/app/圆.png");
  width: 13vw;
  height: 12.2vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.skin-title{
  /*background-image: url("http://data.xiyilab.com/web/main/static/app/当前账号无权查看.png");*/
  min-width: 5.2vw;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 1vw;
}
.skin-lock{
  position: absolute;
  z-index: 10;
  top:1.5vw;
  right:0.5vw;
  margin-top: 1.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/app/锁.png");
  width: 1.2vw;
  height: 1.2vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.mark-pic {

  background-image: url("http://data.xiyilab.com/web/main/static/app/物理_05.png");
  width: 100%;
  height: 32vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.header {
  width: 100%;
  height: 4vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  background-color: white;
}
.header-icon {
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.header-pic {
  height: 2vw;
  width: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
  margin-left: 3vw;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  position: relative;
}
.user-card {
  position: absolute;
  top: 3vw;
  right: -1vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}
.user-card-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 2vw;
  cursor: pointer;
  width: 8vw;
}
.user-btn-pic {
  object-fit: contain;
}
.user-btn-text {
  line-height: 2vw;
  height: 2vw;
  font-size: 0.7vw;
  text-align: center;
  margin-left: 1.5vw;
  white-space: nowrap;
}
.user-card-btn:hover {
  background-color: #f7e35e;
}
.header-title {
  margin: 1vw auto;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.5rem;
  text-align: center;
}

.teacher-body {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width: 85%;
  margin: 2vw auto 1vw;
  display: flex;
  flex-wrap: nowrap;
  min-height: 85vh;
}
.teacher-body-left {
  width: 13vw;
  background-color: #e8e8e9;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/左侧导航bg.png");
  background-size: cover;
  background-position: bottom;
  background-repeat: repeat-y;
}
.switch-classroom {
  margin-top: 0.5vw;
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.icon-classroom {
  background-image: url("http://data.xiyilab.com/web/main/static/home/班级.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 1vw;
  height: 1vw;
  margin: auto 0.5vw auto;
}
.router-btn-group {
  margin-top: 1vw;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.router-btn {
  width: 100%;
  height: 4.25vh;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.router-btn-icon {
  width: 1vw;
  height: 1vw;
  margin-left: 3.5vw;
  margin-right: 1vw;
}
.router-btn-text {
  line-height: 4.25vh;
  font-size: 0.8vw;
}
.router-btn-right-line {
  margin-left: auto;
  height: 2vh;
  margin-top: auto;
  margin-bottom: auto;
  width: 3px;
  background-color: #5eb2f7;
}
.teacher-body-right {
  width: 85%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

}
.select-app-card {
  width: 90%;
  height: 10vw;
  display: flex;
  margin: 1vw auto 0;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
}
.subject-select-btn-group {
  margin-top: 1vw;
  display: flex;
  flex-wrap: nowrap;
  height: 2vw;
  width: 100%;
  line-height: 2vw;
  white-space: nowrap;
}
.task-date-picker {
  display: flex;
  flex-wrap: nowrap;
  height: 40px;
  white-space: nowrap;
  width: 40%;
  min-width: 300px;
  line-height: 40px;
  margin-left: 2vw;
}
.task-name-input {
  min-width: 200px;
  width: 40%;
  display: flex;
  flex-wrap: nowrap;
  height: 40px;
  margin: 0 0 10px;
  white-space: nowrap;
  line-height: 40px;
}
.app-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 65vw;
  margin: 0 auto 1vh;
  scrollbar-width: none; /* Firefox */
}
.app-card {
  width: 13vw;
  height: 9vw;
  margin: 0.75vw 1.5vw 0.75vw;
  min-height: 150px;
  min-width: 150px;
  position: relative;
  border-radius: 4px;
  transition: all 0.3s;
  cursor: pointer;
  background-color: rgba(161, 184, 202, 0.1);
}
.app-card:hover {
  color: #5eb2f7;
}
.app-card:hover .app-icon {

}
.app-card:hover .app-checkbox {
  visibility: inherit;
}
.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 7vw;
  min-height: 120px;
  min-width: 120px;
  border-radius: 4px;
}

.app-title {
  width: 100%;
  text-align: center;
  font-weight: 500;
  font-size: 0.8vw;
  line-height: 2vw;
  height: 2vw;
  color: inherit;
}
.app-checkbox {
  position: absolute;
  top: 0.5vw;
  right: 1vw;
  z-index: 10;
  visibility: hidden;
}
.on-checkbox {
  visibility: inherit;
}
.no-on-checkbox {
  visibility: hidden;
}

/*.app-title {*/
/*  border: 1px red solid;*/
/*  font-weight: 500;*/
/*  font-size: 0.8vw;*/
/*  margin-left: 2vw;*/
/*  line-height: 2vw;*/
/*  height: 2vw;*/
/*  color: inherit;*/
/*}*/
.title-icon {
  width: 20px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: inline-block;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/icon_发布任务.png");
}
.dialog-line {
  width: 90%;
  margin: 0.5vw auto;
  height: 1.2vw;
  line-height: 1.2vw;
  display: flex;
  justify-content: flex-end;
}
.finish-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px white solid;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background-color: #5eb2f7;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 0.3vw;
}
.finish-status-text {
  height: 1.2vw;
  line-height: 1.2vw;
}
.dialog-icon {
  width: 16px;
  height: 16px;
  margin: auto 0.5vw auto;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.icon1 {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/班级小图标.png");
}
.icon2 {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/名称小图标.png");
}
.icon3 {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/时间小图标.png");
}
.dialog-line-text {
  margin-right: auto;
  font-size: 0.7vw;
}
.dialog-task-app {
  width: 90%;
  margin: auto;
  border: 1px #d6dcd5 solid;
  height: 8vw;
  flex-direction: column;

  display: flex;
}
.title-group {
  overflow-y: scroll;
  height: 6.8vw;
}
.title-group::-webkit-scrollbar {
  width: 0 !important;
}
.task-app-title {
  width: 100%;
  height: 2vw;
  line-height: 2vw;
  text-align: center;
  font-size: 0.7vw;
  cursor: pointer;
}

.dialog-body {
  position: relative;
}
.delete-btn {
  width: 100%;
  height: 1.2vw;
  line-height: 1.2vw;
  right: 2vw;
  bottom: 0.5vw;
  font-size: 1vw;
  cursor: pointer;
  text-align: right;
  border-top: 1px #d6dcd5 solid;
}
.task-app-title:hover {
  background-color: #5eb2f7;
}
.mark-manager-header {
  width: 90%;
  margin: 0 auto 0;
  height: 7vh;
  border-bottom: 1px #efefef solid;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
}
.mark-count {
  margin-left: auto;
  margin-right: 1vw;
  width: 4.5rem;
  height: 2rem;
  margin-top: 1.5rem;
  line-height: 2rem;
  white-space: nowrap;
  color: white;
  letter-spacing: 1px;
  text-align: center;
  background-color: #5eb2f7;
  cursor: pointer;
  border-radius: 4px;
}
.header-router-btn {
  display: inline-block;
  cursor: pointer;
}
.left-blue-blank {
  margin-top: 1.75rem;
  margin-left: 0;
  width: 3px;
  background-color: #5eb2f7;
  height: 1.5rem;
}
.manager-header-router {
  height: 2rem;
  line-height: 5rem;
  margin-left: 2vw;
  font-size: 0.7vw;
  margin-bottom: 2vw;
}
.mark-manager-body {
  margin:1vh auto auto;
  width: 90%;
  overflow: auto;
}
.mark-manager-footer {
  height: 2vw;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 90%;
}
.no-task-img {
  width: 100%;
  height: 100%;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/没有任务.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
}
.to-create {
  position: fixed;
  top: 42vh;
  left: 45vw;
  width: 120px;
  height: 40px;
  font-size: 0.9vw;
  text-align: center;
  color: #5eb2f7;
  line-height: 40px;
  cursor: pointer;
}
.no-context{
  position: absolute;
  font-family: test;
  font-weight: 400;
  top: 17vh;
  left: 20vw;
  height: 40px;
  font-size:1vw;
  text-align: center;
  color: black;
  line-height: 40px;
  cursor: pointer;
}
.search-action {
  width: 100%;
  height: 40px;
  margin: 0 0 1vw;
  display: flex;
  justify-content: flex-end;
}
.search-result {
  height: 40px;
  line-height: 40px;
  margin-top: auto;
  margin-left: 1vw;
  margin-right: auto;
}
.table-to-info {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/查看详情.png");

  width: 18px;
  width: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.table-delete-btn {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/删除(1).png");
  width: 18px;
  width: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.status-tag {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  width: 4vw;
  height: 16px;
  line-height: 16px;
}
.status-reject {
  width: 16px;
  height: 16px;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/未开始.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.status-pending {
  width: 16px;
  height: 16px;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/进行中.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.status-resolve {
  width: 16px;
  height: 16px;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/已完成.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.task-info-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 71vh;
}
.task-title{
  height: 10vw;
  width: 100%;
  margin-top: 0;
}
.task-name {
  width: 90%;
  margin-left: 1vw;
  justify-content: flex-start;
  display: flex;
  height: 2vw;
  line-height: 2vw;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 0.8vw;
  font-family: test;
}
.task-name-icon {
  text-align: justify;
  width: 16px;
  margin: auto 0.5vw auto;
  height: 16px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.icon-name {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/名称小图标.png");
}
.icon-classroom-info {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/班级小图标.png");
}
.icon-time {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/时间小图标.png");
}
.icon-star {
  background-image: url("http://data.xiyilab.com/web/main/static/exam/icon_任务内容.png");
}
.justify {
  width: 4vw;
  min-width: 50px;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
}
.justify::after {
  width: 100%;
  display: inline-block;
  content: "";
}
.app-card-group {
  overflow: hidden;
  width: 100%;
  height: 70%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  scrollbar-width: none; /* Firefox */
}
.dialog-foot {
  text-align: center;
  display: flex;
  width: 100%;
  height: 3rem;
  justify-content: center;
  margin-top: 1rem;
}

.search-no-result-img {
  width: 100%;
  height: 32vw;
  background-image: url("http://data.xiyilab.com/web/main/static/exam/无搜索结果.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.excel{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
}
.exam-pic{
  margin: 0 auto 0;
  width: 1100px;
  overflow: auto;
  position: relative;
}

.markList{
  height: 595px;
  width: 143px;
  position: absolute;
  right:25px;
  top:84px;
}
.mark-review-btn{
  width: 143px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  position: absolute;
}
.mark-review-mark{
  line-height: 40px;
  font-size: 16px;
  font-family: test;
}
.mark-review-review{
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
  line-height: 40px;
  cursor: pointer;
}
.excel-title{
  width: 100%;
  height: 10vh;
  border: 1px black solid;
  display: flex;
  justify-content: center;
  align-items: center;
}
.excel-tableList{
  width: 100%;
  height: 100%;
  border: 1px black solid;
  border-top-width:0px ;
  border-right-width:0px ;
  display: flex;
  flex-direction: column;
}
.excel-step{
  display: flex;
  height: 100%;
  border-width:0px;
}
.excel-item{
  width: 100%;
  height: 5vh;
  border: 1px black solid;
  border-left-width:0px ;
  border-top-width:0px ;
  display: flex;
}
.excel-sum{
  width: 100%;
  height: 5vh;

  border: 1px black solid;
  border-top-width:0px ;
  display: flex;

}
.phy-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/物理.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.chem-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/化学.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bio-back{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/生物.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.mark-list{
  width: 8.5vw;
  top:6.5vw;
  height: 60vh;
  right:1vw;
  position: absolute;
  z-index: 999;
  border: 1px red solid;
}
.mark-input{
  white-space: nowrap;
  position: absolute;
  top:0vw;
  font-size: 0.85vw;
  line-height: 4vh;
  height: 4vh;
  width: 8.5vw;
  text-align: center;
}
.app-body::-webkit-scrollbar{
  display: none;
}
.excel-pic{
  background-image: url("http://data.xiyilab.com/web/main/static/陕西实验操作评分细则(1)/化/1.粗盐中难溶性杂质的去除.png");
  width:100%;
  height: 100%;
  background-size: contain;
  background-position: left;
  background-repeat: no-repeat;
  /*width:100%;*/
  /*object-fit: cover;*/
  /*flex: 1;*/
  /*border: 1px red solid;*/
}
.e-chart{
  height: 15vw;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.chart-left{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 30vw;

}
.chart-right{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 30vw;
}
.chart-left-title{
  width: 60%;
  height: 2vw;
  font-family: test;
  font-size: 1vw;
  text-align: left;
  font-weight: 600;
}
.chart-left-content{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 0.8vw;
  font-family: test;

}
.content-round-1{
  height: 1vw;
  width: 1vw;
  border-radius: 50%;
  background-color: rgb(229, 233, 242);
  margin: 0 0.5vw 0;
}
.content-round-2{
  height: 1vw;
  width: 1vw;
  border-radius: 50%;
  background-color: rgb(32, 160, 255);
  margin: 0 0.5vw 0;
}
</style>
